var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 156.81 156.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#New_Gradient_Swatch_copy_2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#New_Gradient_Swatch_copy_2-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.39,
    y1: 123.44,
    x2: 55.01,
    y2: 123.44,
    gradientTransform: "translate(34.67 216.4) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#cbccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 38.1,
    y1: 73.94,
    x2: 3.76,
    y2: 133.41,
    gradientTransform: "translate(34.67 216.4) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#cbccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2",
    x1: 106.35,
    y1: -59.51,
    x2: 188.74,
    y2: 22.88,
    gradientTransform: "translate(162.73 202.73) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cbccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 29.13,
    y1: 228.86,
    x2: 75.74,
    y2: 228.86,
    gradientTransform: "translate(182.01 -148.8) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#cbccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 58.83,
    y1: 179.36,
    x2: 24.5,
    y2: 238.83,
    gradientTransform: "translate(182.01 -148.8) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#cbccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_2-2",
    x1: 46.47,
    y1: 29.69,
    x2: 128.86,
    y2: 112.08,
    gradientTransform: "translate(99.49 -66.67) rotate(45)",
    xlinkHref: "#New_Gradient_Swatch_copy_2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo beli gradient") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.19,88.09l2.9-2.9a9.64,9.64,0,0,1,13.58,0l19.38,19.38a9.62,9.62,0,0,1,0,13.58l-2.9,2.9a9.62,9.62,0,0,1-13.58,0l-9.69-9.69-7.16,7.16a10.14,10.14,0,0,0,0-14.32l-2.53-2.53A9.64,9.64,0,0,1,85.19,88.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.25,120.68a10.15,10.15,0,0,0,14.31,0l19-19a9.62,9.62,0,0,1,13.58,0l2.9,2.9a9.62,9.62,0,0,1,0,13.58L85.19,154a9.63,9.63,0,0,1-13.57,0l-9.69-9.7,16.48-16.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.79,
    y: 53.1,
    width: 23.31,
    height: 116.52,
    rx: 9.6,
    ry: 9.6,
    transform: "translate(-65.43 64.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.62,68.71l-2.91,2.91a9.63,9.63,0,0,1-13.57,0L35.76,52.23a9.61,9.61,0,0,1,0-13.57l2.9-2.91a9.63,9.63,0,0,1,13.57,0l9.7,9.7,7.15-7.16a10.15,10.15,0,0,0,0,14.31l2.54,2.54A9.63,9.63,0,0,1,71.62,68.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.56,36.13a10.15,10.15,0,0,0-14.32,0l-19,19a9.63,9.63,0,0,1-13.57,0l-2.9-2.91a9.61,9.61,0,0,1,0-13.57L71.61,2.8a9.64,9.64,0,0,1,13.58,0l9.69,9.69L78.4,29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 99.71,
    y: -12.81,
    width: 23.31,
    height: 116.52,
    rx: 9.6,
    ry: 9.6,
    transform: "translate(0.48 92.05) rotate(-45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.52bcc26d2f139958d4ddbdc72f3dcf3e.svg";
export { ForwardRef as ReactComponent };